/**
 * contenus-rh.js
 */

import $ from 'jquery';

$(document).ready(function() {
    let cgi = $("body.page-id-687 #colonneCentre3cols");
    cgi.css("width", "auto").css("margin-left", "none").css("margin-right", "none");
});